import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "justify-center items-center flex bg-overlay fixed inset-0 z-50 overflow-hidden"
}
const _hoisted_2 = {
  class: "relative bg-white text-gray-lp-300 max-w-full flex-col flex rounded-lg",
  style: {"max-height":"85vh"}
}
const _hoisted_3 = { class: "flex flex-no-wrap h-full overflow-scroll" }
const _hoisted_4 = {
  style: {"width":"940px"},
  class: "relative p-4 space-y-4"
}
const _hoisted_5 = { class: "flex flex-row items-center justify-between border-b-2 sticky top-0 bg-white z-10 pb-2" }
const _hoisted_6 = { class: "text-20px" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "text-black-lp-300 text-base font-semibold" }
const _hoisted_9 = { class: "flex flex-row items-center space-x-6" }
const _hoisted_10 = { class: "text-red-lp-100 text-xl font-bold flex flex-row items-center space-x-2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "text-base font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.list.mustDeposit")) + " ", 1),
                  _createVNode("span", _hoisted_7, " - " + _toDisplayString(_ctx.detailDataCourier.courierName), 1)
                ]),
                _createVNode(_component_Icons, {
                  name: "close",
                  class: "w-5 cursor-pointer",
                  onClick: _ctx.close
                }, null, 8, ["onClick"])
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailCourierPendingApproval, (item) => {
                return (_openBlock(), _createBlock("div", {
                  key: item.dateGroup,
                  class: "rounded-2xl border border-gray-lp-1400 p-4 flex flex-row justify-between items-center"
                }, [
                  _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$moment(item.dateGroup).format("DD MMMM YYYY")), 1),
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      (item.codAmount)
                        ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.formatPriceRp(item.codAmount)), 1))
                        : _createCommentVNode("", true),
                      (item.codAmount && item.sttAmount)
                        ? (_openBlock(), _createBlock("span", _hoisted_12, "&"))
                        : _createCommentVNode("", true),
                      (item.sttAmount)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                            _createVNode("span", null, _toDisplayString(_ctx.formatPriceWithoutCurrency(item.sttAmount)) + " STT ", 1),
                            _createVNode("span", _hoisted_13, " (" + _toDisplayString(_ctx.formatPriceWithoutCurrency(item.sttPieces)) + " koli) ", 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_LpButton, {
                      title: _ctx.$t('codReconcile.detail.setorHarian'),
                      textColor: "white",
                      onClick: () => _ctx.postCourierDailyDeposit(item)
                    }, null, 8, ["title", "onClick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}